

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import Home from "./components/Home";
import Kundali from './components/Kundali';
import KundaliResult from './components/KundaliResult';
import KundaliMatch from "./components/KundaliMatch";
import KundaliMatchResult from "./components/KundaliMatchResult";
import Documentation from "./components/Documentation";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/kundali" element={<Kundali />} />
          <Route path="/kundali-result" element={<KundaliResult />} />
          <Route path="/kundali-match" element={<KundaliMatch />} />
          <Route path="/kundali-match-result" element={<KundaliMatchResult />} />
          <Route path="/documentation" element={<Documentation />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}

export default App;
